// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Transportationservice() {


const cardData = {


    keyword: "Transportation Service Company in PCMC",

    headingDescription: "Transportation Service Company in PCMC by SSK Logistic supports businesses, manufacturers, distributors, warehouses, retailers, corporate facilities, and commercial establishments with organized goods transportation across Pimpri-Chinchwad and connected industrial corridors. The service covers road transportation, truck movement, full truck load consignments, container transportation, freight movement, cargo transportation, industrial logistics, commercial deliveries, and corporate goods movement. SSK Logistic coordinates transportation according to cargo type, shipment volume, vehicle capacity, pickup location, delivery destination, and scheduling requirements. With PCMC being surrounded by major industrial and manufacturing areas, businesses can use structured transportation support for movement between factories, warehouses, suppliers, distributors, and customer locations across Pune, Maharashtra, and interstate markets.",

    topPlaces: [
        {
            title: "Pimpri",
            description: "Pimpri is a central commercial and industrial area within PCMC with manufacturing units, warehouses, suppliers, and distribution operations. SSK Logistic coordinates goods transportation for businesses moving industrial materials, commercial inventory, equipment, components, and finished products through this busy business zone."
        },
        {
            title: "Chinchwad",
            description: "Chinchwad has a strong industrial and commercial presence with factories, engineering businesses, warehouses, and supplier networks. Transportation requirements can include machinery, raw materials, finished goods, and regular commercial consignments handled through planned truck and freight movement."
        },
        {
            title: "Akurdi",
            description: "Akurdi connects residential, educational, commercial, and industrial activity within the PCMC region. SSK Logistic supports transportation requirements for business supplies, equipment, inventory, packaged cargo, and goods requiring movement between local facilities and wider distribution networks."
        },
        {
            title: "Talawade",
            description: "Talawade is an important industrial and technology-oriented location in PCMC with offices, manufacturing facilities, warehouses, and commercial establishments. Road transportation can be arranged for equipment, business materials, cargo, supplies, and other consignments requiring organized delivery."
        },
        {
            title: "Pimpri-Chinchwad MIDC",
            description: "Pimpri-Chinchwad MIDC supports extensive manufacturing, engineering, automotive, and industrial operations. SSK Logistic coordinates transportation for raw materials, components, machinery, finished goods, and industrial cargo according to vehicle capacity, loading requirements, and delivery schedules."
        },
        {
            title: "Bhosari",
            description: "Bhosari is one of PCMC's established industrial centers with a wide network of factories, suppliers, warehouses, and engineering businesses. Transportation services can support regular movement of industrial materials, commercial products, equipment, and manufacturing-related consignments."
        },
        {
            title: "Moshi",
            description: "Moshi provides access to northern PCMC and nearby Pune logistics corridors, with growing commercial, warehousing, and distribution activity. SSK Logistic can coordinate truck transportation for inventory transfers, packaged goods, industrial materials, equipment, and business cargo."
        },
        {
            title: "Chikhali",
            description: "Chikhali is a developing industrial and residential area in northern PCMC with connections to Chakan and other manufacturing corridors. Businesses can coordinate transportation for construction materials, industrial goods, commercial inventory, machinery, and distribution consignments."
        },
        {
            title: "Tathawade",
            description: "Tathawade has grown into a commercial and business-oriented location with connections to Wakad, Hinjewadi, and wider Pune markets. Transportation support can cover corporate supplies, commercial goods, equipment, packaged cargo, and other business consignments."
        },
        {
            title: "Ravet",
            description: "Ravet connects western PCMC with the Mumbai-Pune highway and surrounding commercial areas, making it relevant for road-based goods movement. SSK Logistic supports transportation planning for commercial cargo, industrial materials, warehouse transfers, and distribution requirements."
        }
    ],

    "services": [
        {
            "name": "transportation company pcmc",
            "description": "SSK Logistic supports businesses searching for a transportation company pcmc for organized movement of commercial and industrial goods. Vehicle selection, pickup planning, cargo handling coordination, route management, and destination delivery can be structured around individual and recurring business requirements."
        },
        {
            "name": "transportation services pcmc",
            "description": "Transportation services pcmc from SSK Logistic cover road movement of goods between factories, warehouses, suppliers, distributors, offices, and commercial destinations. Arrangements can be planned according to cargo volume, vehicle capacity, route requirements, and delivery schedules."
        },
        {
            "name": "transport company pcmc",
            "description": "The transport company pcmc service supports manufacturers, retailers, distributors, wholesalers, and commercial establishments requiring dependable road transportation. SSK Logistic coordinates suitable vehicles and transportation schedules for local, regional, and interstate goods movement."
        },
        {
            "name": "transport service provider pcmc",
            "description": "Businesses requiring a transport service provider pcmc can coordinate their goods movement through SSK Logistic. The service can cover factory transportation, warehouse transfers, commercial deliveries, industrial cargo, truck movement, and distribution requirements across PCMC and connected markets."
        },
        {
            "name": "goods transport company pcmc",
            "description": "The goods transport company pcmc service is suitable for moving packaged products, machinery, industrial materials, components, equipment, commercial inventory, and finished goods. SSK Logistic coordinates road transportation based on shipment quantity, cargo type, vehicle requirements, and destination."
        },
        {
            "name": "goods transportation pcmc",
            "description": "Goods transportation pcmc supports businesses requiring organized movement of materials between manufacturing units, warehouses, suppliers, distribution points, and customer locations. SSK Logistic helps coordinate transportation according to shipment details and operational delivery requirements."
        },
        {
            "name": "logistics company pcmc",
            "description": "SSK Logistic supports the logistics company pcmc requirement with coordinated freight, cargo, industrial, commercial, and warehouse transportation. Businesses can plan regular or project-based goods movement around vehicle requirements, pickup locations, routes, and final delivery points."
        },
        {
            "name": "logistics services pcmc",
            "description": "The logistics services pcmc offering supports businesses with transportation coordination for factories, warehouses, distributors, suppliers, and commercial locations. SSK Logistic can organize truck movement, freight transportation, cargo deliveries, warehouse transfers, and recurring logistics routes."
        },
        {
            "name": "freight transport pcmc",
            "description": "Freight transport pcmc is suitable for businesses moving larger commercial and industrial consignments across PCMC and connected markets. SSK Logistic coordinates freight vehicles according to cargo volume, loading requirements, shipment characteristics, route, and destination."
        },
        {
            "name": "cargo transport pcmc",
            "description": "The cargo transport pcmc service supports movement of commercial products, industrial materials, equipment, components, packaged goods, and business inventory. SSK Logistic plans cargo transportation around shipment size, vehicle capacity, pickup requirements, and delivery location."
        },
        {
            "name": "industrial transport pcmc",
            "description": "Industrial transport pcmc is designed for manufacturing and engineering businesses moving machinery, raw materials, components, production supplies, equipment, and finished goods. SSK Logistic coordinates suitable vehicles and road transportation schedules based on industrial cargo requirements."
        },
        {
            "name": "commercial transport pcmc",
            "description": "The commercial transport pcmc service supports retailers, wholesalers, distributors, corporate facilities, and commercial establishments requiring regular goods movement. Transportation can be coordinated between suppliers, warehouses, business premises, and customer destinations."
        },
        {
            "name": "truck transport pcmc",
            "description": "Truck transport pcmc provides businesses with a practical road transportation option for different commercial and industrial loads. SSK Logistic coordinates appropriate truck capacity based on cargo weight, dimensions, quantity, loading conditions, and final destination."
        },
        {
            "name": "container transport pcmc",
            "description": "Container transport pcmc is suitable for businesses handling larger, standardized, or protected consignments that require containerized road movement. SSK Logistic coordinates appropriate container vehicles according to cargo specifications, loading conditions, route requirements, and delivery schedules."
        },
        {
            "name": "full truck load transport pcmc",
            "description": "The full truck load transport pcmc service supports businesses requiring dedicated vehicle capacity for larger consignments. SSK Logistic coordinates FTL movement for machinery, industrial materials, commercial inventory, packaged products, and other suitable cargo requiring planned direct transportation."
        },
        {
            "name": "road transport company pcmc",
            "description": "Businesses searching for a road transport company pcmc can coordinate interstate, regional, and local goods movement through SSK Logistic. Transportation planning can cover vehicle allocation, pickup coordination, route management, cargo movement, and scheduled destination delivery."
        },
        {
            "name": "reliable transport company pcmc",
            "description": "The reliable transport company pcmc service is structured for businesses seeking planned transportation for recurring and individual consignments. SSK Logistic coordinates suitable vehicles, pickup schedules, cargo requirements, routes, and delivery points according to the shipment."
        },
        {
            "name": "professional transport services pcmc",
            "description": "Professional transport services pcmc from SSK Logistic support organized commercial and industrial goods movement across PCMC and connected regions. Businesses can coordinate transportation according to cargo characteristics, vehicle capacity, delivery requirements, and operational schedules."
        },
        {
            "name": "industrial transportation services pcmc",
            "description": "Industrial transportation services pcmc support movement of machinery, raw materials, equipment, components, production supplies, and finished goods between industrial facilities and warehouses. SSK Logistic plans transportation according to the practical requirements of each industrial shipment."
        },
        {
            "name": "cargo transportation services pcmc",
            "description": "The cargo transportation services pcmc offering supports businesses moving cargo between factories, warehouses, suppliers, distributors, corporate locations, and commercial destinations. SSK Logistic coordinates suitable road transportation based on cargo size, quantity, packaging, and delivery location."
        },
        {
            "name": "freight transportation pcmc",
            "description": "Freight transportation pcmc helps businesses coordinate movement of commercial and industrial freight across PCMC and wider Maharashtra or interstate routes. SSK Logistic supports vehicle planning, cargo movement, route coordination, and delivery scheduling according to shipment requirements."
        },
        {
            "name": "corporate transport services pcmc",
            "description": "Corporate transport services pcmc support businesses requiring movement of office equipment, commercial supplies, inventory, documents, machinery, and other business-related consignments. SSK Logistic coordinates transportation around corporate pickup points, schedules, cargo details, and destination locations."
        },
        {
            "name": "transporters in pcmc",
            "description": "Businesses looking for transporters in pcmc can coordinate commercial and industrial goods movement with SSK Logistic. Transportation arrangements can cover truck loads, warehouse transfers, factory deliveries, cargo movement, distribution consignments, and regular business routes."
        },
        {
            "name": "logistics provider pcmc",
            "description": "The logistics provider pcmc service supports businesses requiring coordinated transportation for supply chains, warehouses, manufacturing units, distributors, and commercial destinations. SSK Logistic helps organize vehicle allocation, freight movement, cargo transportation, and delivery planning."
        },
        {
            "name": "transportation company near pcmc",
            "description": "Businesses searching for a transportation company near pcmc can coordinate road transportation requirements through SSK Logistic for goods movement across PCMC and nearby Pune industrial corridors. Services can be arranged for commercial cargo, industrial materials, warehouse transfers, and distribution consignments."
        }
    ],

    "tableData": [
        ["transportation company pcmc", "transportation services pcmc"],
        ["transport company pcmc", "transport service provider pcmc"],
        ["goods transport company pcmc", "goods transportation pcmc"],
        ["logistics company pcmc", "logistics services pcmc"],
        ["freight transport pcmc", "cargo transport pcmc"],
        ["industrial transport pcmc", "commercial transport pcmc"],
        ["truck transport pcmc", "container transport pcmc"],
        ["full truck load transport pcmc", "road transport company pcmc"],
        ["reliable transport company pcmc", "professional transport services pcmc"],
        ["industrial transportation services pcmc", "cargo transportation services pcmc"],
        ["freight transportation pcmc", "corporate transport services pcmc"],
        ["transporters in pcmc", "logistics provider pcmc"],
        ["transportation company near pcmc", "Transportation Service Company in PCMC"]
    ],

    whychoose: [
        {
            WhyChooseheading: "PCMC-Focused Goods Transportation",
            WhyChoosedescription: "SSK Logistic supports transportation requirements across Pimpri-Chinchwad's industrial, commercial, warehouse, and business locations. Pickup and delivery arrangements can be planned according to the specific location, cargo type, vehicle requirement, and schedule of each shipment."
        },
        {
            WhyChooseheading: "Industrial Cargo Coordination",
            WhyChoosedescription: "Manufacturing businesses can coordinate transportation for machinery, raw materials, components, equipment, production supplies, and finished products. SSK Logistic structures vehicle and route planning around the characteristics of industrial consignments."
        },
        {
            WhyChooseheading: "Flexible Truck Capacity",
            WhyChoosedescription: "Commercial shipments can range from smaller consignments to larger full-load movements. SSK Logistic coordinates suitable truck capacity according to cargo weight, volume, dimensions, loading conditions, and destination requirements."
        },
        {
            WhyChooseheading: "Warehouse and Factory Transfers",
            WhyChoosedescription: "Movement between factories, warehouses, suppliers, and distribution centers is an important part of PCMC's business logistics. Transportation can be scheduled for inventory transfers, finished goods, raw materials, equipment, and recurring supply chain movements."
        },
        {
            WhyChooseheading: "Container Transportation Support",
            WhyChoosedescription: "Businesses handling standardized or larger cargo can coordinate container transportation according to shipment requirements. SSK Logistic helps arrange suitable container vehicles and transportation schedules for commercial and industrial consignments."
        },
        {
            WhyChooseheading: "Commercial Distribution Assistance",
            WhyChoosedescription: "Retailers, wholesalers, distributors, and corporate establishments can coordinate transportation for inventory, packaged goods, equipment, and commercial supplies. Delivery planning can be aligned with warehouse operations and business distribution schedules."
        },
        {
            WhyChooseheading: "Coverage Across PCMC Corridors",
            WhyChoosedescription: "Transportation requirements can arise across Pimpri, Chinchwad, Akurdi, Talawade, Bhosari, Moshi, Chikhali, Tathawade, Ravet, and other connected areas. SSK Logistic coordinates road transportation according to the actual pickup and destination requirements."
        },
        {
            WhyChooseheading: "Planned Business Logistics",
            WhyChoosedescription: "Regular transportation works more efficiently when vehicle allocation, pickup timing, cargo details, routes, and delivery points are clearly coordinated. SSK Logistic supports businesses with structured planning for recurring and individual transportation requirements."
        }
    ]

};



















const faqData = [
    {
        question: "What transportation services does SSK Logistic provide in PCMC?",
        answer: "SSK Logistic supports commercial transportation requirements across PCMC by coordinating suitable vehicles for goods movement based on cargo type, shipment quantity, weight, dimensions, pickup location, delivery destination, and business schedule."
    },
    {
        question: "Can SSK Logistic handle industrial goods transportation in PCMC?",
        answer: "Industrial machinery, components, packaged products, raw materials, equipment, commercial inventory, and other suitable consignments can be considered for transportation after reviewing their size, weight, packaging, loading conditions, and destination."
    },
    {
        question: "Which areas of PCMC are covered by SSK Logistic?",
        answer: "Transportation requirements can be discussed across major PCMC locations such as Pimpri, Chinchwad, Bhosari, Akurdi, Nigdi, Moshi, Chikhali, Talawade, Dapodi, and nearby industrial or commercial areas depending on the shipment requirements."
    },
    {
        question: "Does SSK Logistic provide transportation services for regular business shipments?",
        answer: "Businesses with recurring goods movement requirements can discuss regular transportation arrangements based on shipment frequency, cargo volume, pickup points, delivery locations, vehicle capacity, and their preferred dispatch schedule."
    },
    {
        question: "Can goods be transported from PCMC to other cities through SSK Logistic?",
        answer: "Intercity and interstate transportation can be discussed for suitable commercial consignments moving from PCMC to destinations across Maharashtra and other parts of India, depending on the cargo specifications and required vehicle."
    },
    {
        question: "What types of vehicles are available for transportation in PCMC?",
        answer: "Vehicle selection depends on the cargo weight, dimensions, quantity, packaging, loading method, route, and delivery requirements. SSK Logistic can discuss an appropriate commercial vehicle option after understanding the complete shipment details."
    },
    {
        question: "Can SSK Logistic arrange warehouse-to-warehouse transportation in PCMC?",
        answer: "Warehouse-to-warehouse movement can be coordinated for suitable commercial shipments between storage facilities, factories, distribution centers, warehouses, dealers, and other approved business locations according to the required transportation plan."
    },
    {
        question: "Can bulk goods transportation be arranged from PCMC?",
        answer: "Bulk shipment requirements can be discussed by sharing the cargo type, total quantity, approximate weight, number of packages, loading location, delivery destination, vehicle requirement, and preferred movement schedule."
    },
    {
        question: "How does SSK Logistic plan transportation services for PCMC businesses?",
        answer: "Transportation planning considers the pickup and delivery addresses, cargo category, shipment quantity, weight and dimensions, loading conditions, vehicle capacity, route requirements, delivery schedule, and other operational details provided by the business."
    },
    {
        question: "What information is required to enquire about transportation services in PCMC?",
        answer: "Businesses can share the pickup location, delivery address, cargo details, approximate quantity and weight, dimensions if applicable, loading requirements, preferred vehicle type, shipment frequency, and expected transportation schedule for an appropriate service discussion."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nilesh Jadhav",
        feedback: "Our manufacturing unit in the PCMC area needed regular transportation support for moving finished goods and industrial materials. SSK Logistic understood the shipment requirements and coordinated the vehicle movement according to our dispatch plans.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Snehal Bhosale",
        feedback: "We were looking for transportation support for commercial goods moving from our PCMC warehouse to different locations. The SSK Logistic team collected the cargo and route details properly and made the overall transportation coordination convenient for our business.",
        rating: 5
    }
];






    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Transportation Service Company in PCMC",
  "image": "https://ssklogistics.in/assets/images/transportation-service-company-in-pcmc.webp",
  "description": "SSK Logistics provides Transportation Service Company in PCMC solutions for businesses requiring dependable goods movement, cargo transportation, freight handling and commercial logistics support across Pimpri-Chinchwad. Transportation company PCMC services can support manufacturers, distributors, wholesalers, retailers, warehouses and industrial businesses with regular, scheduled or project-based transportation requirements. Transportation services PCMC can be coordinated according to cargo type, shipment volume, vehicle capacity, pickup requirements and delivery schedules. Transport company PCMC solutions can cover commercial goods, industrial materials, machinery, equipment, packaged products, inventory and other suitable consignments. Transport service provider PCMC requirements can be managed through planned vehicle coordination, route scheduling, pickup arrangements and delivery coordination. Goods transport company PCMC services can support movement between factories, warehouses, suppliers, distribution centers and customer locations across Pimpri-Chinchwad and surrounding industrial areas. SSK Logistics can arrange dedicated vehicles, full truck load transportation and other road transport solutions based on shipment specifications and business schedules. The service can support transportation requirements for industrial zones, commercial establishments, manufacturing units, warehouses and distribution operations throughout PCMC. Flexible transportation planning can be used for different cargo volumes, shipment sizes, delivery frequencies and destination requirements. Businesses seeking a transportation service company in PCMC can coordinate practical goods, cargo and freight movement solutions designed around their operational schedules and supply chain requirements.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/transportation-service-company-in-pcmc"
  }
};



    return (
        <div>
<Helmet>
  <title>
    Transportation Service Company in PCMC | Goods, Cargo & Commercial Transport Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides transportation services in PCMC for goods, cargo, freight and commercial shipments with coordinated road transport solutions for businesses and industries."
  />

  <meta
    name="keywords"
    content="Transportation Service Company in PCMC, transportation company PCMC, transportation services PCMC, transport company PCMC, transport service provider PCMC, goods transport company PCMC, goods transportation PCMC, goods transport services PCMC, goods transporters PCMC, cargo transportation PCMC, cargo transport company PCMC, cargo transport services PCMC, freight transport PCMC, freight transportation PCMC, freight services PCMC, logistics company PCMC, logistics services PCMC, logistics provider PCMC, transport services in PCMC, transportation services in PCMC, commercial transport PCMC, commercial goods transport PCMC, industrial transport PCMC, industrial goods transportation PCMC, industrial cargo transport PCMC, warehouse transport PCMC, warehouse transportation PCMC, distribution transport PCMC, distribution logistics PCMC, truck transport PCMC, truck transportation PCMC, dedicated truck transport PCMC, full truck load transport PCMC, FTL transport PCMC, road transport PCMC, road transportation services PCMC, business transport PCMC, supply chain transportation PCMC, transport contractor PCMC, transportation service provider PCMC, goods transport service provider PCMC, cargo transportation service provider PCMC"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpeg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Transportationservice;